import { useEffect, useState } from "react";
import { Eye, Loader2, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  endViewAsCompany,
  useViewAsCompanySession,
} from "@/modules/platform/platformApi";
import { setActiveViewAsCompany } from "@/modules/platform/viewAsCompanyState";

/**
 * Shown to a platform operator who is viewing the app as another company:
 * which company, read-only, and a way back. Also arms the client-side
 * read-only guard (viewAsCompanyState).
 */
export const ViewAsCompanyBar = () => {
  const { data: session } = useViewAsCompanySession();
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    setActiveViewAsCompany(
      session ? { orgId: session.org_id, orgName: session.org_name } : null,
    );
  }, [session]);

  if (!session) return null;

  const exit = async () => {
    setExiting(true);
    try {
      const orgId = await endViewAsCompany();
      setActiveViewAsCompany(null);
      // Full reload so every cached screen reads as the operator again.
      window.location.assign(orgId ? `/platform/companies/${orgId}` : "/");
    } finally {
      setExiting(false);
    }
  };

  return (
    <div
      role="status"
      className="fixed bottom-4 left-1/2 z-50 flex max-w-[calc(100vw-2rem)] -translate-x-1/2 items-center gap-3 rounded-full bg-warning py-1.5 pl-4 pr-1.5 text-sm font-medium text-warning-foreground shadow-overlay"
    >
      <Eye className="size-4 shrink-0" />
      <span className="truncate">
        Viewing as {session.org_name} · read-only
      </span>
      <Button
        type="button"
        size="sm"
        variant="secondary"
        className="h-7 rounded-full"
        disabled={exiting}
        onClick={() => void exit()}
      >
        {exiting ? (
          <Loader2 className="size-3.5 animate-spin" />
        ) : (
          <LogOut className="size-3.5" />
        )}
        Exit
      </Button>
    </div>
  );
};
